module.exports = __webpack_public_path__ + "img/1200 MK2.8ee2d572.png";